import { fromEvent, switchMap } from 'rxjs';
import getListingCounts$ from 'api/getListingCounts';
import fastdom from 'fastdom';
import { readCookie } from 'modules/cookieManager';

const documentChange$ = fromEvent(document, 'DOMContentLoaded');

const updateListingCounts = function (listingCountsData) {
  const listingCountsContainer = document.querySelector('[data-listing-counts-container]');

  if (listingCountsData && listingCountsContainer){
    fastdom.mutate(() => {
      const fragment = document.createRange().createContextualFragment(listingCountsData);
      listingCountsContainer.appendChild(fragment);
    });
  }
}

documentChange$
.pipe(
  switchMap(() => {
    const personalCookie = readCookie('Personal', true);
    const urlParams = new URLSearchParams(personalCookie);
    const searchTerm = urlParams.get('searchtext');
    const marketId = urlParams.get('market') || 0;
    const searchInput = document.getElementById('blog_typeahead_input');

    if (searchInput && searchTerm){
      searchInput.value = searchTerm;
    }
  
    return getListingCounts$(marketId);
  })
)
.subscribe(updateListingCounts);
